import { Injectable } from "@angular/core";
import { UserNotification } from "../notification/models/user-notification.model";
import { HttpClient } from "@angular/common/http";
import { catchError, EMPTY, Observable, tap, throwError } from "rxjs";
import { environment } from "../../environments/environment";
import { SignalREventService } from "./signal-revent.service";
import { Router } from "@angular/router";

@Injectable({
  providedIn: 'root',
})
export class MessageService {
    private notifications: Array<UserNotification>;
    
    constructor(private http: HttpClient, private signalREventService: SignalREventService, private router: Router) { }

    subscribeToNotifications(onSubscribe: (notifications: Array<UserNotification>) => void, onChange: (notification: UserNotification) => void) {
        if (this.notifications) {
            onSubscribe(this.notifications);
        } else {
            this.getNotifications$(false).pipe(
                tap(result => {
                    this.notifications = result;
                    this.signalREventService.userNotificationReceived$.pipe().subscribe((notification: UserNotification) => {
                        if (notification.isRead) {
                            this.remove(notification);
                        } else {
                            // New notification needs to be at the start
                            this.notifications = [notification].concat(this.notifications);
                        }
                        onChange(notification);
                    });
                    onSubscribe(this.notifications);
                }),
                catchError(() => {
                    return EMPTY;
                })
            ).subscribe();
        }
    }

    remove(notification: UserNotification) {
        const index = this.notifications.findIndex(x => x.notificationId === notification.notificationId);
        if (index !== -1) {
            this.notifications.splice(index, 1);
        }
    }

    getNotifications$(includeRead: boolean): Observable<Array<UserNotification>> {
        return this.http.get<Array<UserNotification>>(`${environment.ppxPrivateApi}api/Notification/${includeRead}`).pipe(
            catchError(err => throwError(err))
        );
    }

    readNotification$(notificationId: number): Observable<void> {
        return this.http.post<void>(`${environment.ppxPrivateApi}api/notification/read/${notificationId}`, null).pipe(
            catchError(err => throwError(err))
        );
    }

    navigateToNotification(notification: UserNotification): void {
        if (notification.itemId) {
            if (notification.notificationType === 1) {
                this.router.navigate(['/tasks'], { replaceUrl: true, onSameUrlNavigation: 'reload', queryParams: { nId: notification.itemId } });
                this.closeNotificationPopupByEvent();
            } else if (notification.notificationType === 2) {
                this.router.navigate(['/pog'], { replaceUrl: true, onSameUrlNavigation: 'reload', queryParams: { nId: notification.itemId } });
                this.closeNotificationPopupByEvent();
            }
        }
    }

    closeNotificationPopupByEvent() {
        const event = new MouseEvent('click', {bubbles: true});
        document.getElementsByClassName('notification-btn')[0].dispatchEvent(event);
    }
}